import { Component, OnInit } from '@angular/core';
import { Login_Data, UserTypes } from 'src/app/models/User';
import {
    setUser as setSentryUser,
    setUser,
    TraceClassDecorator
} from '@sentry/angular';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    GOOGLE_RECAPTCHA_SITE_KEY,
    USER_TYPES
} from 'src/app/constant/constant';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiResult, PromiseResult } from 'src/app/models/PromiseResult';
import { AuthService } from 'src/app/services/auth.service';
import { CountriesService } from 'src/app/services/countries.service';
import { CommunicationService } from '../../shared/communication.service';
import { any } from 'bluebird';
import { VendorPatientService } from '../../../services/vendor.patient.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
    selector: 'app-apyaya-otp',
    templateUrl: './apyaya-otp.component.html',
    styleUrls: [
        './apyaya-otp.component.css',
        './../login-home/login-home.component.css'
    ]
})
@TraceClassDecorator()
export class ApyayaOtpComponent implements OnInit {
    @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;
    readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
    login_data: Login_Data = new Login_Data();
    user_guid = '';
    client_id = '';
    vendor_id = '';
    logo_url: string = '';
    slug: string = "";
    backUrl: string = "";
    constructor(
        private readonly utilitiesService: UtilitiesService,
        public readonly router: Router,
        private readonly route: ActivatedRoute,
        private readonly authservice: AuthService,
        private readonly vendorPatient: VendorPatientService,
        private readonly communicationService: CommunicationService,
        private readonly changeDetector: ChangeDetectorRef,
        private readonly activatedRoute: ActivatedRoute,
        private providerStateService: ProviderStateService
    ) { }

    ngOnInit(): void {
        this.slug = this.providerStateService.getProviderSlug();
        this.backUrl = '/' + this.slug + '/';
        this.setTokens();
        this.logo_url = this.providerStateService.getLogoUrl();
    }
    async openLink(
        base_url_name: string,
        link: string,
        target: string
    ): Promise<void> {
        this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }

    async otpVerifySubmit() {
        this.login_data.otp_data.OTP_validate_api.retry = false;
        await this.login_validate_or_resend_otp();
    }

    async otp_resend() {
        this.login_data.otp_data.OTP_validate_api.retry = true;
        await this.login_validate_or_resend_otp();
    }

    setTokens() {
        this.route.queryParamMap.subscribe(async (res) => {
            if (
                res.get('user_guid') &&
                res.get('client_id') &&
                res.get('vendor_id')
            ) {
                this.user_guid = res.get('user_guid');
                this.client_id = res.get('client_id');
                this.vendor_id = res.get('vendor_id');

                await this.fetchServiceID();
            }
            else this.router.navigate(["/" + this.slug + "/accessdenied"], { relativeTo: this.activatedRoute });
        });
    }

    isPosting(): boolean {
        return (
            this.login_data.login_api_result.Posting ||
            this.login_data.otp_data.otp_api_result.Posting
        );
    }
    resolved(captchaResponse: string) {
        this.login_data.recaptchaData.recaptcha_value = captchaResponse;
        this.login_data.login_modal.recaptcha =
            this.login_data.recaptchaData.recaptcha_value;
    }

    private async fetchServiceID(): Promise<void> {
        await this.vendorPatient.requestotp(this.user_guid, this.client_id, this.vendor_id)
            .toPromise()
            .then(result => {
                if (result.success) {
                    this.login_data.otp_data.OTP_validate_api.user_guid = this.user_guid;
                    this.set_otp_data(result);
                    this.changeDetector.detectChanges();
                    this.OTP_Input.init_countdown();
                }
            }).catch((error: HttpErrorResponse) => {
                this.login_data.login_api_result.ServerError = error.error;
                this.login_data.login_api_result.PromiseResult.success = false;
                this.login_data.login_api_result.Posting = false;
            })
    }

    async login_validate_or_resend_otp() {
        this.login_data.otp_data.otp_api_result = new ApiResult(true);
        await this.authservice
            .login_validate_or_resend_otp_patient(
                this.login_data.otp_data.OTP_validate_api
            )
            .toPromise()
            .then(async (result) => {
                this.login_data.otp_data.otp_api_result.PromiseResult = result;
                if (result.success) {
                    if (this.login_data.otp_data.OTP_validate_api.retry) {
                        this.set_otp_data(result);
                        this.changeDetector.detectChanges();
                        this.OTP_Input.init_countdown();
                    } else {
                        this.login_set_data(result);
                    }
                }
                this.login_data.otp_data.otp_api_result.Posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.login_data.otp_data.otp_api_result.ServerError =
                    error.error;
                this.login_data.otp_data.otp_api_result.PromiseResult.success =
                    false;
                this.login_data.otp_data.otp_api_result.Posting = false;
            });
    }

    set_otp_data(result: PromiseResult) {
        this.login_data.otp_data.OTP_validate_api.service_id =
            result.data.service_id;
        this.login_data.otp_data.OTP_validate_api.retry_after = new Date(
            result.data.retry_after
        );
    }

    login_set_data(result: PromiseResult) {
        sessionStorage.setItem('userid', result.data.userid);
        sessionStorage.setItem('authtoken', result.data.authtoken);
        sessionStorage.setItem('refresh', "true");
        sessionStorage.setItem('refresh_token', result.data.refreshToken);
        sessionStorage.setItem('email', 'default');
        sessionStorage.setItem('name', 'default');
        setSentryUser({
            email: this.login_data.login_modal.email,
            id: result.data.userid,
            role: USER_TYPES.PATIENT
        });
        //Todo: need to change this based on role
        this.setUser(this.login_data.auth_result);

        if (this.login_data.return_url == null) {
            this.router.navigate(['/' + this.slug + '/patient/consultdoctor'], { queryParams: { consultation_type_id: 1 } });
        } else if (this.login_data.return_url != null) {
            this.router.navigate(['/' + this.slug + '/' + this.login_data.return_url]);
        }
    }

    setUser(user: any) {
        this.communicationService.setUser(user);
    }
}
